import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormArray, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { RegistroService } from 'src/app/registro.service';
import { environment } from 'src/environments/environment';
import { BulkCreateProductoBase } from 'src/interfaces/bulk-create-producto-base.interface';
import { PackageResponseInterface } from 'src/interfaces/package-response.interface';
import { ProductTypeResponseInterface } from 'src/interfaces/product-type-response.interface';
import Swal from 'sweetalert2';
import { TipoProductoId } from '../assets/columnas-producto.constants';

@Injectable({
    providedIn: 'root',
})
export class TipoProductoService {
    optProductClassification;
    optProductFertiClassification;
    apiUrl = environment.apiSiriUrl;
    endPointProducto = '';
    tipoProductoId: string;
    constructor(
        private http: HttpClient,
        private registroService: RegistroService,
        private router: Router
    ) {}

    async loadOptTypeProduct() {
        let optProductType;
        try {
            optProductType = await firstValueFrom(
                this.http.get<ProductTypeResponseInterface[]>(
                    `${this.apiUrl}tipo-producto/disponibles/${this.registroService.empresaSelected}`
                )
            );
            return optProductType;
        } catch (error) {
            return console.log(
                'ocurrio un erro al cargar los productos' + error
            );
        }
    }

    async getColumnsPlaguicida(): Promise<any[]> {
        try {
            // Se oculta el endpoint por solicitud  - HU161
            // const response = await firstValueFrom(
            //     this.http.get<any[]>(
            //         `${this.apiUrl}tipo-producto/plaguicida-clasificacion-producto`
            //     )
            // );
            // this.optProductClassification = response;
            const columnasPlaguicida = [
                {
                    nombre: 'Registro ICA',
                    campo: 'numeroRegistroIca',
                    tipo: 'text',
                    obligatorio: true,
                    validaciones: [
                        Validators.required,
                        Validators.pattern('[A-Z0-9]+'),
                    ],
                },
                {
                    nombre: 'Nombre comercial',
                    campo: 'nombreComercial',
                    tipo: 'text',
                    mayusculas: true,
                    obligatorio: true,
                    validaciones: [Validators.required],
                },
                {
                    nombre: 'Casa productora / Planta productora',
                    campo: 'casaProductora',
                    tipo: 'text',
                    obligatorio: true,
                    validaciones: [Validators.required],
                },
                // Se ocultan el siguiente campo por solicitud - HU161
                // {
                //     nombre: 'Clasificación del producto',
                //     campo: 'clasificacion',
                //     tipo: 'selectService',
                //     opciones: this.optProductClassification,
                //     obligatorio: true,
                //     validaciones: [Validators.required],
                // },
                {
                    nombre: 'Origen del producto',
                    campo: 'OrigenDelProducto',
                    tipo: 'select',
                    opciones: ['Producto importado', 'Producto Nacional'],
                    validaciones: [Validators.required],
                },
            ];
            return columnasPlaguicida;
        } catch (error) {
            console.error(
                'Error al cargar opciones de clasificación de producto',
                error
            );
            return [];
        }
    }

    async getColumnsFertilizante(): Promise<any[]> {
        try {
            // Se oculta el endpoint por solicitud  - HU161
            // this.optProductFertiClassification = await firstValueFrom(
            //     this.http.get<any[]>(
            //         `${this.apiUrl}tipo-producto/fertilizante-clasificacion-1`
            //     )
            // );
            return [
                {
                    nombre: 'Registro ICA',
                    campo: 'numeroRegistroIca',
                    tipo: 'text',
                    obligatorio: true,
                    validaciones: [
                        Validators.required,
                        Validators.pattern('[A-Z0-9]+'),
                    ],
                },
                {
                    nombre: 'Nombre comercial',
                    campo: 'nombreComercial',
                    tipo: 'text',
                    mayusculas: true,
                    obligatorio: true,
                    validaciones: [Validators.required],
                },
                {
                    nombre: 'Casa productora / Planta productora',
                    campo: 'casaProductora',
                    tipo: 'text',
                    obligatorio: true,
                    validaciones: [Validators.required],
                },
                // Se ocultan el siguiente campo por solicitud - HU161
                // {
                //     nombre: 'Clasificación',
                //     campo: 'clasificacion',
                //     tipo: 'selectService',
                //     opciones: this.optProductFertiClassification,
                //     obligatorio: true,
                //     validaciones: [Validators.required],
                // },
                {
                    nombre: 'Origen del producto',
                    campo: 'OrigenDelProducto',
                    tipo: 'select',
                    opciones: ['Producto importado', 'Producto Nacional'],
                    validaciones: [Validators.required],
                },
            ];
        } catch (error) {
            console.error(
                'Error al cargar opciones de clasificación de producto',
                error
            );
            return [];
        }
    }

    async postReporteMasivo(productos: any, tipoProducto: string) {
        try {
            // Transformar los productos antes de enviarlos
            const productosTransformados = productos.productos.map(
                (producto: BulkCreateProductoBase) => {
                    let productoTipo: any = {}; // Variable para asignar el objeto dinámicamente
                    let nombretipoProducto;
                    switch (String(tipoProducto)) {
                        case TipoProductoId.Fertilizante:
                            this.endPointProducto = 'fertilizantes';
                            nombretipoProducto = 'fertilizante';
                            productoTipo = {
                                clasificacion1Id: producto.clasificacion,
                            };
                            break;
                        case TipoProductoId.Coadyuvante:
                            this.endPointProducto = 'coadyuvantes';
                            nombretipoProducto = 'coadyuvante';
                            productoTipo = {};
                            break;
                        case TipoProductoId.NutricionAnimal:
                            this.endPointProducto = 'alimentosbalanceado';
                            nombretipoProducto =
                                'alimentoBalanceadoParaAnimales';
                            productoTipo = {};
                            break;
                        case TipoProductoId.Plaguicida:
                            this.endPointProducto = 'plaguicidas';
                            nombretipoProducto = 'plaguicida';
                            productoTipo = {
                                clasificacionProductoId: producto.clasificacion,
                            };
                            break;
                        case TipoProductoId.AcondicionadorEnmienda:
                            this.endPointProducto = 'acondicionadorEnmienda';
                            nombretipoProducto = 'acondicionadorEnmienda';
                            productoTipo = {};
                            break;
                        default:
                            productoTipo = {};
                            break;
                    }
                    return {
                        productoBase: {
                            agenteVigiladoId:
                                this.registroService.empresaSelected,
                            OrigenDelProducto:
                                producto.OrigenDelProducto ||
                                'Producto Nacional',
                            numeroRegistroIca: producto.numeroRegistroIca,
                            nombreComercial: producto.nombreComercial,
                            casaProductora: producto.casaProductora,
                        },
                        [nombretipoProducto]: productoTipo,
                        presentaciones: producto.presentaciones,
                    };
                }
            );
            const url = `${this.apiUrl}carga-masiva-productos/${this.endPointProducto}`;
            const response = await this.http
                .post(url, productosTransformados)
                .toPromise();
            Swal.fire('', 'Productos creados con éxito', 'success').then(
                (result) => {
                    if (result.isConfirmed) {
                        this.router.navigate(['/consultar']);
                    }
                }
            );
        } catch (error) {
            console.error('Error al procesar los productos:', error);
        }
    }

    async loadEmpaquesPresentacion(tipoProducto: string) {
        let optPackaging;
        try {
            switch (String(tipoProducto)) {
                case TipoProductoId.Fertilizante:
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque/fertilizante`
                        )
                    );
                    this.tipoProductoId = TipoProductoId.Fertilizante;
                    return optPackaging;
                case TipoProductoId.Plaguicida:
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque/plaguicida`
                        )
                    );
                    this.tipoProductoId = TipoProductoId.Plaguicida;
                    return optPackaging;
                case TipoProductoId.Coadyuvante:
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque/coadyuvante`
                        )
                    );
                    this.tipoProductoId = TipoProductoId.Coadyuvante;
                    return optPackaging;
                case TipoProductoId.NutricionAnimal:
                    this.tipoProductoId = TipoProductoId.NutricionAnimal;
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque/alimentoBalanceado`
                        )
                    );
                    if (!Array.isArray(optPackaging)) {
                        optPackaging = [optPackaging];
                    }
                    return optPackaging;
                case TipoProductoId.AcondicionadorEnmienda:
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque/acondicionadorEnmienda`
                        )
                    );
                    this.tipoProductoId = TipoProductoId.AcondicionadorEnmienda;
                    return optPackaging;
                default:
                    optPackaging = await firstValueFrom(
                        this.http.get<PackageResponseInterface[]>(
                            `${this.apiUrl}empaque`
                        )
                    );
                    return optPackaging;
            }
        } catch (error) {
            console.error('Error al cargar opciones de Dropdown 2', error);
            return [];
        }
    }

    cargarUnidadMedida(empaqueId: string): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.apiUrl}unidad-medida/by-empaque/${empaqueId}`
        );
    }
    //cargar presentaciones para la unidad seleccionada

    generateCodeUnitMeasurement(
        empaque: string,
        cantidad: number,
        codigoSeleccionado: string
    ): string {
        const targetLength = 5;
        const paddedCantidad = cantidad.toString().padStart(targetLength, '0');
        return `${empaque}${paddedCantidad}${codigoSeleccionado}`;
    }

    onUnidadMedidaChange(
        event: Event,
        productoIndex: number,
        presentacionIndex: number,
        productos: FormArray
    ) {
        const selectedOption = (event.target as HTMLSelectElement)
            .selectedOptions[0];

        // Obtener el código de la unidad de medida
        const codigo = selectedOption.getAttribute('data-codigo') || '';
        const idUnidadMedida = selectedOption.value || '';
        // Acceder al formulario de producto y presentación
        const producto = productos.at(productoIndex);
        const presentaciones = producto.get('presentaciones') as FormArray;
        const presentacion = presentaciones.at(presentacionIndex) as FormGroup;

        // Actualizar el empaqueUnidadMedidaId con el ID de la unidad de medida seleccionada
        presentacion.get('empaqueUnidadMedidaId').setValue(idUnidadMedida);

        // Recalcular el código de presentación basado en empaque, cantidad y el código de la unidad de medida
        this.updateCodeUnitMeasurement(presentacion, codigo);
    }

    updateCodeUnitMeasurement(
        presentacionForm: FormGroup,
        codigoSeleccionado: string
    ) {
        const empaque = presentacionForm.get('empaque')?.value || '';
        const cantidad = presentacionForm.get('cantidad')?.value || 0;
        const empaqueUnidadMedidaId =
            presentacionForm.get('empaqueUnidadMedidaId')?.value || 0;

        if (empaque && cantidad && codigoSeleccionado) {
            const codeUnitMeasurement = this.generateCodeUnitMeasurement(
                empaque,
                cantidad,
                codigoSeleccionado
            );
            presentacionForm
                .get('codigoPresentacion')
                ?.setValue(codeUnitMeasurement);
        }
    }

    activarPresentacion(productos) {
        // Habilitar temporalmente los campos deshabilitados para tomar su valor al enviar
        productos.controls.forEach((productoControl) => {
            if (productoControl instanceof FormGroup) {
                const presentaciones = productoControl.get(
                    'presentaciones'
                ) as FormArray;
                if (presentaciones instanceof FormArray) {
                    presentaciones.controls.forEach((presentacionControl) => {
                        if (presentacionControl instanceof FormGroup) {
                            presentacionControl.get('empaque')?.enable();
                            presentacionControl.get('cantidad')?.enable();
                            presentacionControl
                                .get('empaqueUnidadMedidaId')
                                ?.enable();
                        }
                    });
                }
            }
        });
    }

    validacion(event: KeyboardEvent): void {
        const input = event.target as HTMLInputElement;
        const currentValue = input.value;

        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Enter',
            'Escape',
            'Meta',
            'Control',
            'Shift',
        ];

        if (allowedKeys.includes(event.key)) return;

        if (
            (event.key === ',' || event.key === '.') &&
            (currentValue.includes(',') || currentValue.includes('.'))
        ) {
            event.preventDefault();
            return;
        }

        const key = event.key === ',' ? '.' : event.key;
        const isValidInput = /^[0-9.]$/.test(key);

        if (!isValidInput) {
            event.preventDefault();
            return;
        }

        const simulatedValue = (currentValue + key).replace(',', '.');
        const simulatedNumber = parseFloat(simulatedValue);

        const decimalPart = simulatedValue.split('.')[1];
        if (decimalPart && decimalPart.length > 1) {
            event.preventDefault();
            return;
        }

        if (simulatedNumber > 99999.9) {
            event.preventDefault();
        }
    }

    async validacionProductoDuplicado(registroIca: string): Promise<string> {
        try {
            this.tipoProductoId;
            console.log(this.tipoProductoId);
            const response: any = await firstValueFrom(
                this.http.get(
                    `${this.apiUrl}producto/duplicado/${registroIca}/${this.tipoProductoId}/${this.registroService.empresaSelected}`
                )
            );
            console.log('este el el mesaje de la busqueda' + response);
            return '';
        } catch (error) {
            console.error('Error en la validación:', error);
            return error.error.message;
        }
    }
}
